class ApiService {
  constructor() {
    this.baseUrl = ''; // 你可以在这里设置你的基础 URL
  }

  //  to add authorization token to the headers
  addAuthorizationToken(options) {
    const token = localStorage.getItem("token");
    if (token) {
      options.headers = {
        Accept: "application/json, application/xml, text/plain, text/html, *.*",
        "Content-Type": "application/json",
        ...options.headers,
        Authorization: `Bearer ${token}`,
      };
    }
    return options;
  }

  handleGenericError(response) {
    // Handle generic errors here
    // For example, you can log the error or display a generic error message
    if (!response.ok) {
      return response.json().then((data) => {
        if (data && data.statusCode === 400 && data.shouldDisplayMessage) {
          alert(data.message);
        }
        return Promise.reject(data);
      });
    }
    return response;
  }

  handle401Error(response) {
    if (response.status === 401) {
      window.localStorage.removeItem("token");
      window.location = "/";
    }
    return response;
  }

  async request(url, options) {
    // Add authorization token to headers
    options = this.addAuthorizationToken(options);

    const response = await fetch(url, options);
    this.handle401Error(response);
    this.handleGenericError(response);
    return response.json();
  }

  async getData(url, params) {
    const queryString = params ? "?" + new URLSearchParams(params).toString() : "";
    const response = await this.request(`${this.baseUrl}${url}${queryString}`, {
      method: "GET",
    });
    return response;
  }

  async postData(url, data) {
    const response = await this.request(`${this.baseUrl}${url}`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  }

  async postFile(url, data) {
    const response = await this.request(`${this.baseUrl}${url}`, {
      method: "POST",
      body: data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  }

  async postPDF(url, data) {
    const response = await this.request(`${this.baseUrl}${url}`, {
      method: "POST",
      body: data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    });
    return response;
  }
}

export const apiService = new ApiService();
